import { updateLinksToOpenInNewTabs } from "../../../../utils/product/updateLinksToOpenInNewTab";
import { cleanPromoDescription } from "../../../../utils/product/cleanPromoDescription";
import { Message } from "../../../../types/types";
import styles from "./FeatureMessagesDrawerFeature.module.scss";

interface FeatureMessagesDrawerFeatureProps {
  feature: Message;
}

const FeatureMessagesDrawerFeature = ({
  feature,
}: FeatureMessagesDrawerFeatureProps) => {
  const cleanDescription = cleanPromoDescription(feature) || "";
  const updatedLinksDescription =
    typeof window === "undefined"
      ? cleanDescription
      : updateLinksToOpenInNewTabs(cleanDescription);

  return (
    <div
      data-testid="feature-messages-drawer-feature"
      className={styles.feature}
    >
      <h3 className={styles.featureTitle}>{feature.title}</h3>
      <div
        dangerouslySetInnerHTML={{
          __html: updatedLinksDescription,
        }}
      />
    </div>
  );
};

export default FeatureMessagesDrawerFeature;
